<template>

    <div class="page" v-if="ready">

        <router-view
            :key="$route.name"
            @showLoading="showLoading"
            ref="refPage"
            v-if="sceneLoaded">

        </router-view>

        <loading v-if="isLoading" ref="refLoading" />

        <canvas ref="refCanvas" @resize="onResize" />

    </div>

    <div class="loading" v-else> <span class="sr-only">LOADING</span> </div>
    <div class="rotate-screen"><span>Tourne ton écran</span></div>

</template>

<script>

    export default
    {
        name: "App"
    }

</script>


<script setup>

    import { onMounted, ref, nextTick  }    from "vue";
    import {Howl, Howler}                   from 'howler';
    import { useMainStore }                 from "./stores/main";
    import { storeToRefs }                  from "pinia";
    import { useTitle }                     from '@vueuse/core';
    import CurlSimple                       from "./game/CurlSimple";
    import GameLauncher                     from "./game/GameLauncher";
    import Events                           from "./game/events/Events";
    import Loading                          from "./components/Loading.vue";
    import useSound                         from "./composables/useSound";


    let store = useMainStore();

    let {  fadeAndStopPlaying } = useSound();

    const { route, router} = store
    const { ready, user, lang, lastPage } = storeToRefs(store)

    let title = useTitle()

    let refPage = ref(null);
    let refCanvas = ref(null);
    let refLoading = ref(null);
    let sceneLoaded = ref (false);

    let contextAudioIsReady = ref(false);


    let isLoading = ref(true);

    router.beforeEach((to, from, next) => {

        let scene = "";
        let done = "";

        lastPage.value = from?.name ?? "";

        let strFrom = (from?.name ?? "home");

        if (to.name === 'game-1')
        {
            if (strFrom.indexOf("home") === 0)
            {
                scene = "foret-1";
                done = "start-game-1";
            }
        }
        else if (to.name === 'game-2' && from.name.indexOf("home") === 0)
        {
            scene = "foret-1";
        }
        else if (( to?.name ?? '').indexOf("home") === 0)
        {
            scene = "foret-intro";
            fadeAndStopPlaying("narrator");
            fadeAndStopPlaying("music");
            document.dispatchEvent(new CustomEvent(Events.ChangeEmotion, {detail: {emotion: "default"}}));
        }

        document.dispatchEvent(new CustomEvent("route-change", {detail: {scene, done}}));


        next();

    });

    function showLoading ()
    {
        isLoading.value = true;

        // if (refLoading)
        // {
        //     refLoading.value.start();
        // }
    }

    function hideLoading ()
    {
        isLoading.value = false;

        if (refLoading)
        {
            refLoading.value.stop();
        }
    }

    function resizeCanvas ()
    {
        if (refCanvas.value)
        {
            refCanvas.value.width = window.innerWidth;
            refCanvas.value.height = window.innerHeight;
        }
        else {

        }
    }


    // function loadAndPlayAudio (url)
    // {
    //     if (!contextAudioIsReady)
    //     {
    //         try
    //         {
    //             let audioContext = new AudioContext();
    //             // your code here
    //         }
    //         catch (e)
    //         {
    //             console.log("Caught an error: ", e.message);
    //             return;
    //         }
    //     }
    //
    //
    //         var sound = new Howl({
    //                                  src: [url]
    //                              });
    //
    //         sound.play();
    //
    //         console.log("loadAndPlayAudio", url);
    //
    // }

    window.addEventListener('resize', resizeCanvas);
    document.addEventListener("loading", onShowLoading)


    let game = null;

    function onShowLoading (e)
    {
        isLoading.value = e.detail.loading ?? e.detail.show ?? false;

        //setTimeout( () => startLoading(), 10);

    }

    function startLoading ()
    {
        if (!refLoading.value)
        {
            setTimeout( () => startLoading(), 10);
            return;
        };

        if (isLoading.value)
        {
            refLoading.value.start();
        }
        else
        {
            refLoading.value.stop();
        }
    }
    function onSceneLoaded ()
    {
        if (refPage.value && refPage.value.onSceneLoaded)
        {
            refPage.value.onSceneLoaded();
        }
        else
        {
            nextTick(  ()  => //we want to wait for the next tick to make sure the router-view is loaded
                       {
                           //if (refPage.value && (refPage.value.onSceneLoaded ?? false))
                           setTimeout( () => onSceneLoaded(), 10);
                       });
        }
    }

    onMounted(async () =>
    {


        resizeCanvas();

        game = new GameLauncher(refCanvas.value);


        document.addEventListener(Events.SceneLoaded, (e) =>
        {
            sceneLoaded.value = true;
            onSceneLoaded();

        });
    })


</script>


<style scoped>

canvas
{
    position:absolute;
    top:0;
    left:0;
    z-index:-1;
}

#loader
{
    position:absolute;
    top:20px;
    left:20px;
    width:200px;
    height:40px;
    background-color:red;
}
</style>
